import { useQuery } from '@tanstack/react-query';
import { listLocations, getLocationById } from '@core/services/locationService';
import { useAccountSelectionStore } from '@core/store/accountSelectionStore';

const LOCATIONS_KEY = 'locations';
const FIVE_MIN = 5 * 60 * 1000;

export function useLocations(options = {}) {
  const activeAccountId = useAccountSelectionStore((s) => s.activeAccountId);
  return useQuery({
    queryKey: [LOCATIONS_KEY, 'list', activeAccountId],
    queryFn: () => listLocations({ accountId: activeAccountId }),
    staleTime: FIVE_MIN,
    enabled: options.enabled !== false && Boolean(activeAccountId),
  });
}

export const useLocationById = (id, options = {}) =>
  useQuery({
    queryKey: [LOCATIONS_KEY, 'detail', id],
    queryFn: () => getLocationById(id),
    staleTime: FIVE_MIN,
    enabled: options.enabled !== false && Boolean(id),
  });
